module.exports = __webpack_public_path__ + "static/media/yq-icon.d16ef6c5.png";